export default {
  title: 'Prestazioni settimanali',
  messages_sent: 'Messaggi inviati',
  messages_delivered: 'Messaggi consegnati',
  click_rate: 'Tasso di clic medio',
  awaiting: 'In attesa di conferma',
  legend: {
    sent: 'Inviato',
    clicked: 'Cliccato',
    delivered: 'Consegnato',
  },
  error_messages: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
};
